import React from 'react';
import styled from 'styled-components';
import { palette, font } from 'styled-theme';

const Styles = {
  Indicator: styled.div`
  position: absolute;
  z-index: 1310;
  bottom: 0;
  left: 0;
  padding: 5px 10px;
  color: white;
  font-family: ${font('pre')};
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: ${palette('shadows', 4)};
  background: ${palette('green', 5)};
`,
}

const getEnvironment = () => {
  switch (process.env.REACT_APP_ENV) {
    case 'stage':
      return 'Staging';
    case 'local':
      return 'Local';
    default:
      return null;
  }
}

const EnvIndicator = () => {
  const currentEnv = getEnvironment();
  return (
    <React.Fragment>
      {
        currentEnv &&
          <Styles.Indicator className='envIndicatior'>{`ENV: ${currentEnv}`}</Styles.Indicator>
      }      
    </React.Fragment>
  );
}

export default EnvIndicator;


// WEBPACK FOOTER //
// ./src/components/envIndicator/index.js